export const createQuizMachine = () => {
    const states = {
        consent: {
            actions: {
                onEnter: () => {
                    console.info("[SOB] Showing consent form");
                },
            },
            transitions: {
                CONSENT_GIVEN: {
                    target: "quiz",
                    action: (context) => {
                        context.consentGiven = true;
                    },
                },
                CONSENT_DENIED: {
                    target: "declined",
                    action: (context) => {
                        context.consentGiven = false;
                    },
                },
            },
        },
        declined: {
            actions: {
                onEnter: () => {
                    console.info("[SOB] User declined consent");
                },
            },
            transitions: {},
        },
        quiz: {
            actions: {
                onEnter: () => {
                    console.info("[SOB] Entered quiz state");
                },
            },
            transitions: {
                CONSENT_GIVEN: {
                    target: "quiz",
                    action: (context) => {
                        context.consentGiven = true;
                    },
                },
                ANSWER: {
                    target: "quiz",
                    action: (context, payload) => {
                        context.answers.push({
                            question_id: payload.question_id,
                            answer_id: payload.answer_id,
                            type: payload.type,
                            reference_name: payload.reference_name,
                            local_translation: payload.local_translation,
                        });
                    },
                },
                COMPLETE: {
                    target: "completion",
                },
            },
        },
        completion: {
            actions: {
                onEnter: async (context) => {
                    try {
                        console.info("[SOB] Quiz completed", context.answers);
                    }
                    catch (error) {
                        if (error instanceof Error) {
                            context.error = error.message;
                            context.nextState = "error";
                        }
                    }
                },
            },
            transitions: {},
        },
        error: {
            actions: {},
            transitions: {},
        },
    };
    const machine = {
        value: "",
        context: {
            answers: [],
            currentTransition: null,
        },
        initialize(hasConsent) {
            this.value = hasConsent ? "quiz" : "consent";
            if (hasConsent) {
                this.context.consentGiven = true;
                states[this.value].actions.onEnter?.(this.context);
            }
        },
        async transition(event) {
            const currentState = states[this.value];
            const transition = currentState.transitions[event.type];
            if (!transition) {
                throw new Error(`No transition found for event ${event.type} in state ${this.value}`);
            }
            if (transition.action) {
                const payload = "payload" in event ? event.payload : undefined;
                await transition.action(this.context, payload);
                this.value = this.context.nextState || transition.target;
                this.context.nextState = undefined;
            }
            else {
                this.value = transition.target;
            }
            const newState = states[this.value];
            await newState.actions.onEnter?.(this.context);
            return {
                value: this.value,
                context: this.context,
            };
        },
    };
    return machine;
};
//# sourceMappingURL=stateMachine.js.map